import type { BrandItem, User } from '../types';

export const LOCAL_DEV_BYPASS_QUERY = 'dev_bypass';

const LOCAL_DEV_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]', '::1']);

export const LOCAL_DEV_BYPASS_USER: User = {
  user_id: 'local-dev-admin',
  email: 'local-dev-admin@localhost',
  avatar: '',
  name: 'Local Dev Admin',
};

export const LOCAL_DEV_BYPASS_BRAND: BrandItem = {
  id: '233749',
  name: 'nextop',
  appId: '233749',
  createdAt: '',
  updatedAt: '',
};

export function shouldEnableLocalDevBypass(locationLike: {
  hostname: string;
  search: string;
}) {
  const hostname = locationLike.hostname.trim().toLowerCase();
  if (!LOCAL_DEV_HOSTS.has(hostname)) {
    return false;
  }

  const params = new URLSearchParams(locationLike.search);
  return params.get(LOCAL_DEV_BYPASS_QUERY) === '1';
}
